import React from 'react'

import { Provider } from './Provider'

export const wrapPageElement = ({ element, props }) => (
  <Provider pageContext={ props.pageContext }>{ element }</Provider>
)
